import RichtextAdapter from "modules/storyblok/adapters/RichtextAdapter";
import isEmpty from "modules/storyblok/adapters/RichtextAdapter/utils/isEmpty";
import {
  ChakraAccordionItem as AccordionItem,
  ChakraAccordionButton as AccordionButton,
  ChakraFlex as Flex,
  ChakraAccordionIcon as AccordionIcon,
  ChakraAccordionPanel as AccordionPanel,
  ChakraAccordion,
} from "@airhelp/react-ui-components";
import type { SbEditableComponentProps } from "types/storyblok";
import { storyblokEditable } from "@storyblok/react";
import type { ISbRichtext } from "storyblok-js-client";
import { trackCustomEvent } from "utils/tracking";
import { accordionHeaderStyles, accordionContentStyles } from "./Accordion.styles";
import type { AccordionProps } from "./Accordion.d";

const Accordion = ({
  items,
  icons: { close, open } = {
    close: <AccordionIcon color="primary.500" />,
    open: <AccordionIcon color="primary.500" />,
  },
  variant = "primary",
  sbEditable,
  gaEvent,
}: SbEditableComponentProps<AccordionProps>) => {
  const handletrackEvents = (isExpanded: boolean, content: ISbRichtext) => {
    const text = content.content[0]?.content[0]?.text;
    if (!isExpanded && gaEvent) trackCustomEvent(gaEvent, text);
  };

  const accordionItems =
    items &&
    items.map((item) => (
      <AccordionItem key={item._uid} boxShadow="none" {...storyblokEditable(item)}>
        {({ isExpanded }) =>
          !isEmpty(item.header) && (
            <>
              <AccordionButton onClick={() => handletrackEvents(isExpanded, item.header)}>
                <Flex justify="space-between" textAlign="left" align={{ mobile: "flex-start", lg: "center" }} w="full">
                  <RichtextAdapter content={item.header} customStyles={accordionHeaderStyles} />
                  {isExpanded ? close : open}
                </Flex>
              </AccordionButton>
              <AccordionPanel>
                <RichtextAdapter content={item.body} customStyles={accordionContentStyles} />
              </AccordionPanel>
            </>
          )
        }
      </AccordionItem>
    ));

  return (
    <ChakraAccordion variant={variant} allowToggle {...sbEditable}>
      {accordionItems}
    </ChakraAccordion>
  );
};

export default Accordion;
